"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = require("prop-types");

var _styles = require("@qc-modules/styles");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ItemBox = (0, _styledComponents["default"])(_primitives["default"].Button).withConfig({
  displayName: "distributors-links__ItemBox",
  componentId: "sc-1s9h6qg-0"
})(["", ";&:focus{background-color:", ";}&:hover,&:focus{color:", ";fill:", ";", "}"], (0, _styles.transitionEase)("0.7s", ["background-color", "color"]), function (props) {
  return (0, _styles.colors)("white", props);
}, function (props) {
  return (0, _styles.themeDarken)("0.15", "blue", props);
}, function (props) {
  return (0, _styles.themeDarken)("0.15", "blue", props);
}, function (_ref) {
  var theme = _ref.theme;
  return theme && theme.breakpointInts ? (0, _styledComponents.css)(["@media (min-width:", "px){background-color:", ";}"], theme.breakpointInts[1], (0, _styles.colors)("background-ultra-light", {
    theme: theme
  })) : null;
});
var itemFontObject = {
  alignItems: "center",
  display: ["flex", "flex", "inline-block"],
  flex: ["1 1 auto", "1 1 auto", "0 1 auto"],
  fontSize: [2, 2, 1],
  fontWeight: 1,
  justifyContent: ["space-between", "space-between", "flex-start"],
  letterSpacing: "0.5px",
  lineHeight: 2,
  tag: "div",
  textAlign: "left"
};
var boxStyling = {
  color: "blue",
  cursor: "pointer",
  fill: "blue",
  py: ["21px", "21px", "12px"],
  textDecoration: "none"
};
var propTypes = {
  baseIndex: _propTypes.number,
  itemClickHandler: _propTypes.func,
  itemFocusHandler: _propTypes.func,
  itemRefs: (0, _propTypes.shape)({
    current: _propTypes.array
  }),
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    icon: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.func]),
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    label: _propTypes.string,
    name: _propTypes.string,
    tag: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]),
    url: _propTypes.string,
    value: _propTypes.string
  })),
  px: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number]),
  toggleShowDropdown: _propTypes.func
};

var DistributorsLinks = function DistributorsLinks(_ref2) {
  var _ref2$baseIndex = _ref2.baseIndex,
      baseIndex = _ref2$baseIndex === void 0 ? 0 : _ref2$baseIndex,
      itemRefs = _ref2.itemRefs,
      _ref2$items = _ref2.items,
      items = _ref2$items === void 0 ? [] : _ref2$items,
      itemClickHandler = _ref2.itemClickHandler,
      itemFocusHandler = _ref2.itemFocusHandler,
      _ref2$px = _ref2.px,
      px = _ref2$px === void 0 ? [3, 3, 4] : _ref2$px,
      toggleShowDropdown = _ref2.toggleShowDropdown;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _utils.mapIndexed)(function (item, index) {
    var Icon = item.icon,
        id = item.id,
        name = item.name,
        tag = item.tag,
        target = item.target,
        url = item.url;
    return /*#__PURE__*/_react["default"].createElement(ItemBox, _extends({
      key: id,
      as: tag || (url ? "a" : "button"),
      href: url,
      onClick: function onClick(event) {
        (0, _utils.callIfFunc)(toggleShowDropdown, event);
        (0, _utils.callIfFunc)(itemClickHandler, Object.assign({
          event: event
        }, item));
      },
      onFocus: function onFocus() {
        return (0, _utils.callIfFunc)(itemFocusHandler, index + baseIndex);
      },
      onKeyDown: function onKeyDown(event) {
        if (event.key === "Enter") {
          event.target.click();
        }
      },
      px: px,
      ref: itemRefs ? function (element) {
        // eslint-disable-next-line no-param-reassign
        itemRefs.current[index + baseIndex] = element;
        return element;
      } : null,
      role: "menuitem",
      target: target
    }, boxStyling), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, itemFontObject, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
      display: "inline",
      mr: [1, 1, "4px"],
      tag: "span"
    }, name), Icon && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
      alignItems: "center",
      display: "inline-flex",
      flex: "0 0 auto",
      height: [24, 24, 12],
      verticalAlign: "middle",
      width: [24, 24, 12]
    }, /*#__PURE__*/_react["default"].createElement(Icon, {
      fill: "inherit",
      height: "100%",
      width: "100%"
    }))));
  }, items));
};

DistributorsLinks.propTypes = propTypes;
var _default = DistributorsLinks;
exports["default"] = _default;